module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "turkiyesigorta.8352a9cd.png";